// extracted by mini-css-extract-plugin
module.exports = {"modalBackground":"styles_modalBackground__2beNn","p0Login":"styles_p0Login__3yogP","modal":"styles_modal__2rZpi","modalContent":"styles_modalContent__lpB7x"};